import type {Nullable} from './utility-types';

export function valueOrNull<T>(value: T): Nullable<NonNullable<T>> {
  return value || null;
}
